/**
 * Item class
 * @module components/Item
 */
import * as THREE from 'three';
import config from '../config';
import { loadTexture, mapNormal, randMinMax } from '../util';
class Item {

    constructor(props) {

        this.props = props;
        this.index = props.index;
        this.cam = props.cam;
        this.isLoaded = false;

        //requires rectangles, default size 30
        this.size = Math.max(this.props.widthInCm, this.props.heightInCm) || 30;
        this.size /= 25; //scale down, 100cm equals 4 units in 3D space
        
        this.element = null;
        this.sinPhase = 0;
        this.randomSeed = Math.random();
        this.randomPosition = new THREE.Vector3();
        this.currentPosition = new THREE.Vector3();
        this.desiredPosition = new THREE.Vector3();

        this.currentRotation = new THREE.Quaternion();
        this.desiredRotation = new THREE.Quaternion();

        this.desiredOpacity = 0;
    }

    load() {

        const filename = this.props.workID.replace(/-/g, '');
        const geometry = new THREE.PlaneGeometry(this.size, this.size);
        const filepath = config.paths.sprite + filename + '.png';

        return loadTexture(filepath)
            .then(texture => new THREE.MeshBasicMaterial({ map: texture, side: THREE.DoubleSide, alphaTest: 0.1 }))
            .then(material => {
                material.transparent = true;
                material.opacity = 0;
                this.isLoaded = true;
                this.element = new THREE.Mesh(geometry, material);
                this.element.item = this;
                return this.element;
            });
    }

    update() {

        if(!this.isLoaded) return;
        const elem = this.element;

        //OPACITY
        elem.material.opacity += (this.desiredOpacity - elem.material.opacity)/66;

        //SLERP POSITION
        this.currentPosition.lerp(this.desiredPosition, mapNormal(this.randomSeed, 0.01, 0.1));
        elem.position.copy(this.currentPosition);

        //SLERP ROTATION
        this.currentRotation.slerp(this.desiredRotation, mapNormal(this.randomSeed, 0.005, 0.02));
        elem.quaternion.copy(this.currentRotation);

        //LEVITATE
        elem.position.y = this.currentPosition.y + Math.sin(this.sinPhase/100)*0.05;

        this.sinPhase += mapNormal(this.randomSeed, 0.1, 1);
    }
}

export default Item;
